export default __webpack_public_path__ + "static/media/gan.d706e376.png";